import {Field} from 'formik';

import {
    FormikSelect,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';
import {CodeRepositoriesAutocomplete} from '../../code-repositories/inputs/CodeRepositoriesAutocomplete';
import {PipelineTemplatesAutocomplete} from '../../pipeline-templates/inputs/PipelineTemplatesAutocomplete';
import {DeploymentAccountGroupsAutocomplete} from '../../deployment-account-groups/inputs/DeploymentAccountGroupsAutocomplete';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Pipeline Details'}>
                <Field
                    name='name'
                    label='Name'
                    description='Please enter the pipeline name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter pipeline description'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='pipelineType'
                    label='Pipeline Type'
                    description='Please select the pipeline type'
                    component={FormikSelect}
                    data={[
                        {value: 'APPLICATION', label: 'Application'},
                        {value: 'API', label: 'API'},
                        {value: 'DATABASE', label: 'Database'},
                        {value: 'INFRASTRUCTURE', label: 'Infrastructure'},
                        {value: 'LIBRARY', label: 'Library'},
                        {value: 'SERVICE', label: 'Service'},
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='templateId'
                    label='Template'
                    description='Please select the pipeline template'
                    component={PipelineTemplatesAutocomplete}
                    my={'xl'}
                />

                <Field
                    name='buildCommand'
                    label='Build Command'
                    description='Please enter the build command'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='pipelineStatus'
                    label='Status'
                    description='Pipeline status'
                    component={FormikSelect}
                    data={[
                        {value: 'CREATING', label: 'Creating'},
                        {value: 'ACTIVE', label: 'Active'},
                        {value: 'UPDATING', label: 'Updating'},
                        {value: 'FAILED', label: 'Failed'},
                        {value: 'DELETING', label: 'Deleting'},
                        {value: 'ARCHIVED', label: 'Archived'},
                        {value: 'IMPORTED', label: 'Imported'},
                        {value: 'MIGRATING', label: 'Migrating'},
                        {value: 'MIGRATED_PENDING_CLEANUP', label: 'Migrated Pending Cleanup'},
                    ]}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Deployment'}>
                <Field
                    name='deploymentAccountGroupId'
                    label='Account Group'
                    description='Please select the deployment account group'
                    component={DeploymentAccountGroupsAutocomplete}
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Repository'}>
                <Field
                    name='codeRepositoryName'
                    label='Code Repository'
                    description='Please select the code repository'
                    component={CodeRepositoriesAutocomplete}
                    withAsterisk
                    my={'xl'}
                />
                <Field
                    name='branchName'
                    label='Branch Name'
                    description='Please enter the branch name'
                    component={FormikTextInput}
                    my={'xl'}
                />
            </PlatformFieldset>

        </Stack>
    );
};
